(() => {
  if (window.avStationReady) return;
  window.avStationReady = true;
  let request;
  const track = (event, variant, result) => {
    try { window.AvonticAnalytics?.track(event, {product_id:window.AvonticAnalyticsConfig?.productId,product_handle:window.AvonticAnalyticsConfig?.productHandle,variant_id:variant,component:'workforce_station',result}); } catch {}
  };
  const controls = root => [...root.querySelectorAll('[data-station-option]')];
  const byKind = (root, kind) => root.querySelector(`[data-kind="${kind}"]`);
  const choiceName = select => select?.selectedOptions[0]?.dataset.name || '';
  async function update(root, focusId) {
    const model = byKind(root, 'model');
    if (!model.value) return;
    request?.abort();
    request = new AbortController();
    const button = root.querySelector('[data-station-add]');
    button.disabled = true;
    root.setAttribute('aria-busy', 'true');
    const ids = controls(root).sort((a,b) => Number(a.dataset.position)-Number(b.dataset.position)).map(s => s.value);
    const url = new URL(root.dataset.productUrl, location.origin);
    url.searchParams.set('section_id', root.dataset.sectionId);
    url.searchParams.set('option_values', ids.join(','));
    try {
      const res = await fetch(url, {signal:request.signal});
      if (!res.ok) throw new Error('Your selection could not be loaded. Please try again.');
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const next = doc.querySelector('[data-station-root]');
      if (!next || !next.dataset.variantId || !byKind(next,'model').value) throw new Error('This combination is unavailable. Please choose another option.');
      root.replaceWith(next);
      const clean = new URL(location.href);
      clean.searchParams.delete('option_values');
      clean.searchParams.set('variant', next.dataset.variantId);
      history.replaceState({}, '', clean);
      track('av_variant_resolved', next.dataset.variantId, next.querySelector('[data-station-add]').disabled ? 'unavailable' : 'available');
      if (focusId) document.getElementById(focusId)?.focus({preventScroll:true});
    } catch (e) {
      if (e.name === 'AbortError') return;
      root.querySelector('[data-station-error]').textContent = e.message;
      root.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-station-option]')) return;
    const root = event.target.closest('[data-station-root]');
    const color = byKind(root,'color');
    const preview = root.querySelector('.st-color-photo');
    if (preview && color.selectedOptions[0]?.dataset.preview) {
      preview.src = color.selectedOptions[0].dataset.preview;
      preview.removeAttribute('srcset');
      root.querySelector('[data-color-caption]').textContent = choiceName(color);
    }
    root.querySelector('[data-model-codes]').textContent = choiceName(byKind(root,'model'));
    update(root, event.target.id);
  });
  document.addEventListener('submit', async event => {
    if (!event.target.matches('.st-native-form')) return;
    event.preventDefault();
    const form = event.target, root = form.closest('[data-station-root]');
    const button = form.querySelector('[data-station-add]');
    if (button.disabled || !byKind(root,'model').value) return;
    const label = button.textContent;
    track('av_add_to_cart_attempt', form.elements.id.value, 'attempted');
    button.disabled = true;
    button.textContent = 'Adding your complete setup…';
    const error = root.querySelector('[data-station-error]');
    error.textContent = '';
    try {
      const base = window.Shopify?.routes?.root || '/';
      const response = await fetch(base+'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[{id:form.elements.id.value,quantity:1}]})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Unable to add this setup. Please try again.');
      track('av_add_to_cart_success', form.elements.id.value, 'success');
      location.assign(base+'cart');
    } catch (e) {error.textContent = e.message; button.disabled=false; button.textContent=label;}
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-station-link]');
    if (!link) return;
    const root = link.closest('[data-station-root]');
    try {sessionStorage.setItem('av-station-selection', JSON.stringify({path:new URL(link.href).pathname,family:root.dataset.family,model:choiceName(byKind(root,'model')),color:choiceName(byKind(root,'color')),finish:choiceName(byKind(root,'finish'))}));} catch {}
  });
  function restore() {
    const root = document.querySelector('[data-station-root]');
    if (!root || new URL(location.href).searchParams.has('variant')) return;
    let saved;
    try {saved=JSON.parse(sessionStorage.getItem('av-station-selection'));sessionStorage.removeItem('av-station-selection');}catch{return;}
    if (!saved || saved.path!==location.pathname || saved.family!==root.dataset.family || !saved.model) return;
    const model = byKind(root,'model');
    for (const kind of ['model','color','finish']) {
      const select=byKind(root,kind);if(!select)continue;
      const option=[...select.options].find(o=>o.dataset.name===saved[kind]);
      if(option)select.value=option.value;
    }
    if (!model.value) {root.querySelector('[data-station-error]').textContent='Your previous iPad model is not offered with this stand. Choose a listed model, or return to Elevate or Floor.';return;}
    update(root);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',restore,{once:true});else restore();
})();
